// Take-latest para actions de fetch que compiten (el usuario cambia filtros
// más rápido de lo que responde el backend): sólo la llamada más reciente es
// "fresca" — una respuesta vieja que llega tarde se marca `stale` para que el
// caller la descarte sin commitear, y un error viejo se traga (se devuelve en
// el resultado en vez de lanzarse). Reemplaza los counters `seq` ad-hoc de los
// stores.
//
// Además aborta el request anterior vía AbortController: el `signal` se pasa
// al producer para que viaje en el config de axios. Con axios 0.21 el signal
// se ignora (inofensivo); el abort real se activa al subir a axios 1.x.
//
// Uso en una action:
//     const runLatest = createTakeLatest(); // una instancia por concern
//     const { value, stale, error } = await runLatest((signal) =>
//         apiCall(params, { signal }),
//     );
//     if (stale) return; // no commitear, no resetear loading
export function createTakeLatest() {
    let seq = 0;
    let controller = null;
    return async function run(producer) {
        const mySeq = ++seq;
        if (controller) controller.abort();
        controller = typeof AbortController !== "undefined" ? new AbortController() : null;
        const isStale = () => mySeq !== seq;
        try {
            const value = await producer(controller ? controller.signal : undefined);
            return { value, stale: isStale() };
        } catch (error) {
            if (isStale()) return { value: null, stale: true, error };
            throw error;
        }
    };
}
